import React from 'react'
import { FiCalendar } from '@react-icons/all-files/fi/FiCalendar'
import { FiCheck } from '@react-icons/all-files/fi/FiCheck'
import { FiGrid } from '@react-icons/all-files/fi/FiGrid'
import { FiMail } from '@react-icons/all-files/fi/FiMail'
import { FiMessageCircle } from '@react-icons/all-files/fi/FiMessageCircle'
import { FiPhone } from '@react-icons/all-files/fi/FiPhone'
import { FiUsers } from '@react-icons/all-files/fi/FiUsers'
import Action from '../primitives/Action'
import Container from '../foundations/Container'
import styles from './HomepagePathChoiceV2.module.scss'

const linkIcons = {
  browse: FiGrid,
  chat: FiMessageCircle,
  email: FiMail,
  phone: FiPhone,
}

const pathIcons = {
  'managed-production': FiUsers,
  'online-planning': FiCalendar,
}

const HomepagePathChoiceV2 = ({ content, paths = [] }) => (
  <section className={styles.section} aria-labelledby='homepage-path-choice-heading'>
    <Container width='wide'>
      <header className={styles.header}>
        {content?.subheading && <span className={styles.eyebrow}>{content.subheading}</span>}
        <h2 id='homepage-path-choice-heading'>{content?.heading}</h2>
        {content?.body && <p>{content.body}</p>}
      </header>

      <div className={styles.grid}>
        {paths.map((path, index) => {
          const PathIcon = pathIcons[path.key] || FiCalendar
          const featured = index === 0

          return (
            <article className={`${styles.card} ${featured ? styles.featured : ''}`} key={path.key}>
              <div className={styles.cardHeading}>
                <span className={styles.cardIcon} aria-hidden='true'><PathIcon /></span>
                <span className={styles.cardLabel}>{path.label}</span>
              </div>

              <h3>{path.title}</h3>
              <p className={styles.cardBody}>{path.body}</p>

              <ul className={styles.features}>
                {(path.features || []).map(feature => (
                  <li key={feature}>
                    <FiCheck aria-hidden='true' />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <Action
                dataConversionChannel={path.key === 'managed-production' ? 'quote' : 'builder'}
                dataConversionKey={`homepage.path-choice.${path.key}.primary`}
                dataConversionLocation='path-choice'
                dataConversionSalesPath={path.key === 'managed-production' ? 'managed' : 'self_service'}
                icon={PathIcon}
                onClick={path.cta?.onClick}
                size='large'
                variant={featured ? 'primary' : 'outline'}
                className={styles.primaryAction}
              >
                {path.cta?.label}
              </Action>

              <div className={styles.secondaryActions} aria-label={`${path.label} contact options`}>
                {(path.links || []).map(link => {
                  const LinkIcon = linkIcons[link.type]
                  const isExternal = link.url?.startsWith('tel:') || link.url?.startsWith('mailto:')
                  const href = link.type === 'chat' ? undefined : link.url

                  return (
                    <Action
                      dataConversionChannel={link.type}
                      dataConversionKey={`homepage.path-choice.${path.key}.${link.type}`}
                      dataConversionLocation='path-choice'
                      dataConversionSalesPath={path.key === 'managed-production' ? 'managed' : 'self_service'}
                      external={isExternal}
                      href={href}
                      icon={LinkIcon}
                      key={link.label}
                      onClick={link.onClick}
                      size='compact'
                      variant='plain'
                      className={styles.secondaryAction}
                    >
                      {link.label}
                    </Action>
                  )
                })}
              </div>
            </article>
          )
        })}
      </div>

      {content?.settings?.note && <p className={styles.note}>{content.settings.note}</p>}
    </Container>
  </section>
)

export default HomepagePathChoiceV2
